<div class="chat-popup-container">
  <!-- Chat Window -->
  <div class="chat-window" *ngIf="isChatOpen">
    <!-- Header -->
    <div class="chat-header">
      <h3>DOMA Agent</h3>
      <button class="close-btn" mat-icon-button (click)="toggleChat()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Message Area -->
    <div class="chat-body" #chatBody>
      <div class="messages-container">
        <div *ngFor="let msg of messages" class="message-row" [ngClass]="{'message-row-user': msg.sender === 'user', 'message-row-agent': msg.sender === 'agent'}">
          <div *ngIf="msg.sender === 'agent'" class="agent-avatar">A</div>
          
          <div class="message-bubble" [ngClass]="msg.sender === 'user' ? 'user-message' : 'agent-message'">
            <div *ngIf="msg.files?.length" class="message-file-chips">
              <div *ngFor="let file of msg.files" class="message-file-chip">
                <mat-icon>insert_drive_file</mat-icon>
                <span>{{ file.name }}</span>
              </div>
            </div>
            <app-progress-bar *ngIf="msg.action_type === 'show_progress_bar'" [progress]="msg.progress ?? 0" [label]="msg.text"></app-progress-bar>
            <app-streaming-text *ngIf="msg.sender === 'agent'" [content]="msg.formattedText || msg.text" [isStreamingActive]="msg.isStreaming ?? false" (contentUpdated)="scrollToBottom()"></app-streaming-text>
            <div *ngIf="msg.sender === 'user' && (msg.formattedText || msg.text)" [innerHTML]="msg.formattedText || msg.text"></div>
          </div>
          
          <div *ngIf="msg.sender === 'user'" class="user-avatar">U</div>
        </div>
        <!-- Typing Indicator -->
        <div *ngIf="isLoading" class="message-row message-row-agent">
          <div class="agent-avatar">A</div>
          <div class="message-bubble agent-message typing-indicator">
            <span class="thinking-text">Thinking...</span>
            <div class="dot"></div><div class="dot"></div><div class="dot"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Input Area -->
    <div class="chat-footer">
      <div class="input-container">
        <!-- File Previews -->
        <div *ngIf="selectedFiles.length > 0" class="file-chips">
          <div *ngFor="let file of selectedFiles" class="file-chip">
            <mat-icon>insert_drive_file</mat-icon>
            <span>{{ file.name }}</span>
            <button mat-icon-button (click)="removeFile(file)" matTooltip="Remove">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>

        <div class="composer-row">
          <!-- Upload Icon inside the input box -->
          <label class="upload-icon" matTooltip="Upload file">
            <input type="file" multiple (change)="onFileSelected($event)" hidden />
            <mat-icon>attach_file</mat-icon>
          </label>

          <textarea class="chat-input" placeholder="Type a message..." [(ngModel)]="currentMessage" (keyup.enter)="sendMessage()"></textarea>
          <button class="send-btn" (click)="sendMessage()" mat-icon-button [disabled]="isLoading || (!currentMessage.trim() && selectedFiles.length === 0)">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Floating Chat Icon -->
  <button class="chat-fab" mat-fab (click)="toggleChat()">
    <mat-icon>{{ isChatOpen ? 'close' : 'chat' }}</mat-icon>
  </button>
</div>
